export default "/images/vendor/flag-icon-css/flags/4x3/bi.svg?3fce551eeb9f82d29f7683f31173db5e";